const tokens = (state = {
    items: [],
    fetched: false,
    error: false,
    loading: false
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return Object.assign({}, state, {
                items: [],
                fetched: false,
                error: false,
                loading: false
            });

        case 'TOKENS_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: action.payload.tokens.filter(token => !!token),
                loading: false,
                fetched: true,
                error: false
            });

        case 'TOKENS_FETCH_FAILED':
            return Object.assign({}, state, {
                loading: false,
                fetched: true,
                error: true
            });

        case 'TOKEN_CREATE_SUCCEEDED':
        case 'TOKEN_CREATE_SOCKET':
            return Object.assign({}, state, {
                items: [action.payload.token, ...state.items]
            });

        case 'TOKEN_REMOVE_REQUESTED':
        case 'TOKEN_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.items.filter(team => team.id !== action.payload.tokenId)
            });

        default:
            return state;
    }
}

export default tokens;
